import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { ImagesListName } from '@/common/utils/ImagesListName';
import { getCulpritCustomerAttachedImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerAttachedImages/getCulpritCustomerAttachedImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

const CulpritAttachedVehicleImagesTab = () => {
  const { id } = useParams();

  const { data: imagesData } = useQuery(
    getCulpritCustomerAttachedImagesQueryOptions({
      id: Number(id),
    }),
  );

  return (
    <>
      {!imagesData?.vehicle?.length && !imagesData?.damaged_parts?.length ? (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      ) : null}
      {imagesData?.vehicle?.length ? (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            تصاویر دور تا دور وسیله‌نقلیه
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.vehicle?.map((vehicleImages, index) => {
              return (
                <ImageCard
                  key={vehicleImages.id}
                  imageData={{
                    name: ImagesListName({
                      titleType: 'attachment',
                      index,
                    }),
                    src: vehicleImages.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : null}
      {imagesData?.damaged_parts?.length ? (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            تصاویر نقاط آسیب‌دیده
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.damaged_parts?.map((vehicleImages) => {
              return (
                <ImageCard
                  key={vehicleImages.id}
                  imageData={{
                    name: vehicleImages.title?.fa_const,
                    src: vehicleImages.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : null}
    </>
  );
};

export default CulpritAttachedVehicleImagesTab;
